module.exports = __webpack_public_path__ + "static/media/bg22.11a9dcf9.jpg";